module.exports = __webpack_public_path__ + "img/header-logo.e88fce41.png";